import {
  CreatePermissionHasUserBulkInput,
  CreatePermissionHasUserInput,
  CreatePermissionHasUserResponse,
  PermissionHasUserEffectEnum,
} from '@/models/gen/graphql';
import { validateObj } from '@/utils/custom';

import { CreatePermissionHasUserBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

const validatePermissionHasUser = validateObj({
  userId: (val: string): string => val || '',
  permissionId: (val: string): string => val || '',
  effect: (val: PermissionHasUserEffectEnum): PermissionHasUserEffectEnum => val || PermissionHasUserEffectEnum.Allow,
});

type CreatePermissionHasUserBulkGraphApiResponse = GraphApiResponse<typeof CreatePermissionHasUserBulkDocument>;

const createPermissionHasUserBulkResponseSelector = (
  res: CreatePermissionHasUserBulkGraphApiResponse
): CreatePermissionHasUserResponse[] =>
  !res.errors ? ((res?.createPermissionHasUserBulk?.output || []) as CreatePermissionHasUserResponse[]) : undefined;

const [runCreatePermissionHasUserBulk] = graphApi(CreatePermissionHasUserBulkDocument);

const createPermissionHasUserBulk = async (
  permissionHasUser: CreatePermissionHasUserInput[]
): Promise<CreatePermissionHasUserResponse[]> => {
  const input: CreatePermissionHasUserBulkInput = {
    values: permissionHasUser.map(validatePermissionHasUser),
  };
  const res = await runCreatePermissionHasUserBulk({ input });
  const selected = createPermissionHasUserBulkResponseSelector(res);

  return selected;
};

export const useCreatePermissionHasUserBulk = createGraphApiHook(createPermissionHasUserBulk);

export default createPermissionHasUserBulk;
